<script setup lang="ts"></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20" fill="none">
    <path d="M6.5 6.5 L13.5 13.5 M13.5 6.5 L6.5 13.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
  </svg>
</template>
